import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import BankContratTypeMixteHandler from '../../containers/mixtes/bank/BankContratTypeFormHandler/BankContratTypeMixteHandle';

export default function ContratType() {
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
          Type Contrat
        </CC.Text>
        <BankContratTypeMixteHandler />
      </CC.Box>
    </>
  );
}
